import "./LocalSeoConsultantMiltonKeynes.module.css";
import Header from "@/reusable_sections/Header";
import Consultancy from "./sections/Consultancy";
import Services from "./sections/Services";
import Process from "./sections/Process";
import Service from "./sections/Service";
import Consultation from "./sections/Consultation";
import Localseofaq from "./sections/Localseofaq";
import Localimpact from "./sections/Localimpact";
import ConsultantBenefits from "./sections/ConsultantBenefits";
import Localhero from "./sections/Localhero";
import MiltonKeynes from "./sections/MiltonKeynes";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantMiltonKeynesPage() {
  return <div>
      <Header />
      <Consultancy />
      <Services />
      <Process />
      <Service />
      <Consultation />
      <Localseofaq />
      <Localimpact />
      <ConsultantBenefits />
      <Localhero />
      <MiltonKeynes />
      <Footer />
    </div>;
}